import { START_GIVEAWAY } from 'root/src/shared/descriptions/endpoints/endpointIds'

import startGiveawayPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/startGiveawayPayloadSchema'

export default {
	[START_GIVEAWAY]: {
		payloadSchema: startGiveawayPayloadSchema,
	},
}
